import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import Table from "../../../_common/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../../_common/AlertModal";
import EditLaborModal from "./EditLaborModal";
import LaborDetails from "./LaborDetails";
import VerifyLaborModal from "./VerifyLaborModal";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import contractorActions from "../../../../_actions/contractorActions";
import AddLaborModal from "./AddLaborModal";
import "../styles/projAdmin.css";
import laborActions from "../../../../_actions/laborActions";
import feederListActions from "../../../../_actions/feederListActions";

class ProjLaborList extends Component {
  state = {
    contractorFilter: null,
    laborFilter: "",
    selectedTrade: null,
    selectedLaborId: null,
    isNew: true,
    sortColumn: { path: "fullName", order: "asc" },
    paginateBy: { value: 10 },
    showEditProjLaborModal: false,
    showAddLaborModal: false,
    showEditLaborModal: false,
    showVerifyLaborModal: false,
    showAlert_deleteLaborConfirm: false,
    showAlert_deleteLaborSuccess: false,
    showAlert_projLaborHasLinks: false,
  };

  columns = [
    {
      path: "fullName",
      label: "Name",
      thClassName: "th-labor-name",
      content: (labor) => (
        <span className={`${labor.mergedWithLaborId && "text-muted"}`}>
          {labor.fullName}
        </span>
      ),
    },
    {
      path: "trade",
      label: "Trade",
      thClassName: "th-labor-trade",
      content: (labor) => (
        <span className={`${labor.mergedWithLaborId && "text-muted"}`}>
          {this.getTradeTitle(labor.defaultTradeTradeId)}
        </span>
      ),
    },
    {
      path: "contractorName",
      label: "Contractor",
      thClassName: "th-labor-contractor",
      content: (labor) => (
        <span className={`${labor.mergedWithLaborId && "text-muted"}`}>
          {this.getContractorName(labor.contractorId)}
        </span>
      ),
    },
    {
      path: "isVerified",
      label: "Pend. Status",
      thClassName: "th-labor-pendStatus",
      content: (labor) =>
        labor.isVerified ? (
          <span className="badge badge-success p-1">Verified</span>
        ) : labor.mergedWithLaborId ? (
          <span className="badge badge-warning p-1">Merged</span>
        ) : (
          <span className="badge badge-secondary p-1">Pending</span>
        ),
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;
    dispatch(feederListActions.getAllTrades());
    dispatch(laborActions.getAll(projectId));
    dispatch(contractorActions.getAllForProject(projectId));
  }

  getContractorName = (ctrId) => {
    const { projContractorList } = this.props;
    const ctr = (projContractorList || []).find((c) => c.contractorId === ctrId);
    if (ctr) return ctr.name;
    return "(N/A)";
  };

  getTradeTitle = (tradeId) => {
    const { tradeList } = this.props;
    const trade = (tradeList || []).find((t) => t.tradeId === tradeId);
    if (trade) return trade.title;
    return "(N/A)";
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleChange_contractorFilter = (contractorFilter) =>
    this.setState({ contractorFilter });

  handleChange_laborFilter = (e) => this.setState({ laborFilter: e.target.value });

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ laborFilter: "", contractorFilter: null });
  };

  handleClick_editLabor = (e) => {
    e.preventDefault();
    this.setState({ isNew: false }, this.toggleEditLaborModal);
  };

  onAddNewLabor = () => this.setState({ isNew: true }, this.toggleAddLaborModal);

  deleteLabor = () => {
    const { dispatch, projectId } = this.props;
    const { selectedLaborId } = this.state;
    dispatch(laborActions.deleteLabor(selectedLaborId, projectId));
    this.setState({ selectedLaborId: null });
  };

  handleClick_laborTr = (selectedLabor) => {
    const { dispatch, projectId } = this.props;
    this.setState({ selectedLaborId: selectedLabor.laborId }, () => {
      dispatch(laborActions.getDetails(projectId, selectedLabor.laborId));
    });
  };

  toggleAddLaborModal = () =>
    this.setState({ showAddLaborModal: !this.state.showAddLaborModal });

  toggleEditLaborModal = () =>
    this.setState({ showEditLaborModal: !this.state.showEditLaborModal });

  toggleEditProjLaborModal = () =>
    this.setState({
      showEditProjLaborModal: !this.state.showEditProjLaborModal,
    });

  toggleVerifyLaborModal = () =>
    this.setState({ showVerifyLaborModal: !this.state.showVerifyLaborModal });

  toggleAlert_deleteLaborConfirm = () =>
    this.setState({
      showAlert_deleteLaborConfirm: !this.state.showAlert_deleteLaborConfirm,
    });

  toggleAlert_deleteLaborSuccess = () =>
    this.setState({
      showAlert_deleteLaborSuccess: !this.state.showAlert_deleteLaborSuccess,
    });

  toggleAlert_projLaborHasLinks = () =>
    this.setState({
      showAlert_projLaborHasLinks: !this.state.showAlert_projLaborHasLinks,
    });

  handleAlert_deleteLaborConfirm = (action) => () => {
    if (action === "accept") this.deleteLabor();
    this.toggleAlert_deleteLaborConfirm();
  };

  handleAlert_projLaborHasLinks = () => (e) => {
    e.preventDefault();
    // Close the current alert
    this.toggleAlert_projLaborHasLinks();
    // Open VerifyLaborModal
    this.toggleVerifyLaborModal();
  };

  getData = () => {
    const { projLaborList } = this.props;
    const { contractorFilter, laborFilter, sortColumn } = this.state;

    const filteredByContractor =
      contractorFilter !== null
        ? (projLaborList || []).filter((l) => l.contractorId === contractorFilter.value)
        : projLaborList;
    const filteredByLabor =
      laborFilter !== ""
        ? filteredByContractor.filter((l) =>
            l.fullName.toLowerCase().includes(laborFilter.trim().toLowerCase())
          )
        : filteredByContractor;
    return _.orderBy(filteredByLabor, [sortColumn.path], [sortColumn.order]);
  };

  renderTableFilters = () => {
    const { laborFilter, contractorFilter } = this.state;
    const { permissions, projContractorList, dispatch, projectId } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap w-100 pa-filter-group mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1 mr-2">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="laborFilter"
              id="laborFilter"
              type="search"
              className="form-control"
              value={laborFilter}
              onChange={this.handleChange_laborFilter}
              placeholder="Name"
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__select pa-filter-item__select--contractor mr-2">
          <Select
            name="contractorFilter"
            id="contractorFilter"
            value={contractorFilter}
            options={projContractorList && getProjContractorOptions(projContractorList)}
            onChange={this.handleChange_contractorFilter}
            isSearchable={false}
            isClearable
            placeholder="Contractor"
          />
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addNewLabor"
            id="addNewLabor"
            className="btn btn-info mr-2"
            onClick={this.onAddNewLabor}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="user-plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="test"
            id="test"
            className="btn btn-secondary"
            onClick={() => dispatch(laborActions.downloadAll(projectId))}
          >
            <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
            CSV
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedLaborId,
      sortColumn,
      showEditLaborModal,
      showAddLaborModal,
      showVerifyLaborModal,
      showAlert_projLaborHasLinks,
      showAlert_deleteLaborConfirm,
      showAlert_deleteLaborSuccess,
      isNew,
    } = this.state;
    const { projectId, projLaborList } = this.props;
    const data = this.getData();
    const labor = data.find((l) => l.laborId === selectedLaborId);
    return (
      <React.Fragment>
        <div className="d-flex flex-row w-100 p-2">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-hover table-sm pa-list__table"
                data={data}
                idPropName="laborId"
                selectedItemId={selectedLaborId && selectedLaborId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_laborTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card w-100 sticky-top top-margin-30">
              <div className="card-header bg-lightgray">Labor Details</div>
              <div className="card-body p-3">
                <LaborDetails
                  projectId={projectId}
                  laborId={selectedLaborId}
                  contractorName={labor && this.getContractorName(labor.contractorId)}
                  trade={labor && this.getTradeTitle(labor.defaultTradeTradeId)}
                  handleClick_editLabor={this.handleClick_editLabor}
                  toggleVerifyLaborModal={this.toggleVerifyLaborModal}
                  toggleEditLaborModal={this.toggleEditLaborModal}
                  toggleAlert_projLaborHasLinks={this.toggleAlert_projLaborHasLinks}
                  toggleAlert_deleteLaborConfirm={this.toggleAlert_deleteLaborConfirm}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditLaborModal && (
          <EditLaborModal
            projectId={projectId}
            laborId={selectedLaborId}
            showEditLaborModal={showEditLaborModal}
            toggleEditLaborModal={this.toggleEditLaborModal}
            isNew={isNew}
          />
        )}
        {showAddLaborModal && (
          <AddLaborModal
            projectId={projectId}
            contractorId={0}
            dispatchCallback={this.addLaborCallback}
            showAddLaborModal={showAddLaborModal}
            toggleAddLaborModal={this.toggleAddLaborModal}
          />
        )}
        {showVerifyLaborModal && (
          <VerifyLaborModal
            projectId={projectId}
            labor={data.find((l) => l.laborId === selectedLaborId)}
            projLaborList={projLaborList}
            toggleVerifyLaborModal={this.toggleVerifyLaborModal}
            showVerifyLaborModal={showVerifyLaborModal}
          />
        )}
        {showAlert_projLaborHasLinks && (
          <AlertModal
            alertKey="alertKey_projLaborHasLinks"
            alertTitle="Warning"
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText={
              "This labor is referenced by other project data. Editing " +
              "information will cause all related documents to be amended.\n" +
              "Select OK to continue."
            }
            acceptCaption="OK"
            acceptClass="danger"
            provideReject={false}
            handleAlertAction={this.handleAlert_projLaborHasLinks}
            showAlertModal={showAlert_projLaborHasLinks}
            toggleAlertModal={this.toggleAlert_projLaborHasLinks}
          />
        )}
        {showAlert_deleteLaborSuccess && (
          <AlertModal
            alertTitle="Delete Successful"
            alertTitleClass="bg-success text-white"
            alertTitleIcon="check"
            alertText="Requested delete operation was successful."
            acceptCaption="OK"
            acceptClass="secondary"
            provideReject={false}
            handleAlertAction={this.toggleAlert_deleteLaborSuccess}
            showAlertModal={showAlert_deleteLaborSuccess}
            toggleAlertModal={this.toggleAlert_deleteLaborSuccess}
          />
        )}
        {showAlert_deleteLaborConfirm && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to delete this labor entry?"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_deleteLaborConfirm}
            showAlertModal={showAlert_deleteLaborConfirm}
            toggleAlertModal={this.toggleAlert_deleteLaborConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projLaborList: state.labors.projLaborLists[ownProps.projectId]
    ? state.labors.projLaborLists[ownProps.projectId]
    : null,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  tradeList: state.feederLists.tradeList || null,
});

export default connect(mapStateToProps)(ProjLaborList);
